import * as Y from "yjs";
import { fromUint8Array, toUint8Array } from "js-base64";
import { invoke } from "./bridge";
import type { DocMeta } from "../App";

export interface BuiltSnapshot {
  docId: string;
  docType: string;
  docTitle: string;
  updateB64: string;
}

// Compact every local document (the implicit "today" doc + all user docs) into a
// single encoded Yjs snapshot each. Shared by onboarding (push to an invite) and
// peer-handoff resync (fulfill a behind peer's request). Returns plaintext snapshot
// bytes; the bridge encrypts them with the group key before they leave the device.
export async function buildSnapshots(): Promise<BuiltSnapshot[]> {
  const docs = await invoke<DocMeta[]>("list_documents", {});
  const allDocs = [
    { docId: "today", docType: "today", title: "Today" },
    ...docs.map((d) => ({ docId: d.docId, docType: d.docType, title: d.title })),
  ];

  const snapshots: BuiltSnapshot[] = [];
  for (const doc of allDocs) {
    try {
      const updates = await invoke<string[]>("load_updates", { docId: doc.docId });
      if (updates.length === 0) continue;

      const yDoc = new Y.Doc();
      for (const b64 of updates) Y.applyUpdate(yDoc, toUint8Array(b64), "snapshot");
      const snapshot = Y.encodeStateAsUpdate(yDoc);
      yDoc.destroy();

      snapshots.push({
        docId: doc.docId,
        docType: doc.docType,
        docTitle: doc.title,
        updateB64: fromUint8Array(snapshot),
      });
    } catch (e) {
      console.warn(`Snapshot generation failed for ${doc.docId}:`, e);
    }
  }
  return snapshots;
}
